import React from 'react';
import styled from 'styled-components';

export const Terms = (): React.ReactElement => {
  return (
    <div>
      <BlueH2>Web Site Terms and Conditions of Use</BlueH2>
      <br />
      <p>This page states the &quot;Terms and Conditions&quot; under which you may use LiveXchange.</p>
      <p>
        Please read this page carefully. If you do not accept the Terms and Conditions stated here, do not use this web
        site and service. By using this web site, you are indicating your acceptance to be bound by the terms of these
        Terms and Conditions.
      </p>
      <p>
        LiveXchange (the &quot;Company&quot;) may revise these Terms and Conditions at any time by updating this
        posting. You should visit this page periodically to review the Terms and Conditions, because they are binding on
        you. The terms &quot;You&quot; and &quot;User&quot; as used herein refer to all individuals and/or entities
        accessing this web site for any reason.
      </p>
      <p>Use of Material.</p>
      <p>
        The Company authorizes you to view and download a single copy of the material on LiveXchange (the &quot;Web
        Site&quot;) solely for your personal, noncommercial use. The contents of this Web Site, such as text, graphics,
        images, logos, button icons, software and other &quot;Material&quot;, are protected under both Canadian and
        foreign copyright, trademark and other laws. All Material is the property of the Company or its content
        suppliers or clients. The compilation (meaning the collection, arrangement and assembly) of all content on this
        Web Site is the exclusive property of the LiveXchange and protected by Canadian and international copyright
        laws. Unauthorized use of the Material may violate copyright, trademark, and other laws. You must retain all
        copyright, trademark, service-mark and other proprietary notices contained in the original Material on any copy
        you make of the Material. You may not sell or modify the Material or reproduce, display, publicly perform,
        distribute, or otherwise use the Material in any way for any public or commercial purpose. The use of the
        Material on any other web site or in a networked computer environment for any purpose is prohibited.
      </p>
      <p>
        You shall not copy or adapt the HTML code that the Company creates to generate its pages. It is also protected
        by the Company’s copyright.
      </p>
      <p>Acceptable Site Use.</p>
      <p>
        General Rules: Users may not use the LiveXchange Web Site in order to transmit, distribute, store or destroy
        material (a) in violation of any applicable law or regulation, (b) in a manner that will infringe the copyright,
        trademark, trade secret or other intellectual property rights of others or violate the privacy, publicity or
        other personal rights of others, or (c) that is defamatory, obscene, threatening, abusive or hateful.
      </p>
      <p>
        Web Site Security Rules. Users are prohibited from violating or attempting to violate the security of the Web
        Site, including, without limitation,
      </p>
      <p>
        (a) accessing data not intended for such user or logging into a server or account which the user is not
        authorized to access,
      </p>
      <p>
        (b) attempting to probe, scan or test the vulnerability of a system or network or to breach security or
        authentication measures without proper authorization,
      </p>
      <p>
        (c) attempting to interfere with service to any user, host or network, including, without limitation, via means
        of submitting a virus to the Web Site, overloading, &quot;flooding&quot;, &quot;spamming&quot;,
        &quot;mailbombing&quot; or &quot;crashing&quot;,
      </p>
      <p>(d) sending unsolicited e-mail, including promotions and/or advertising of products or services, or</p>
      <p>
        (e) forging any TCP/IP packet header or any part of the header information in any e-mail or newsgroup posting.
        Violations of system or network security may result in civil or criminal liability. The Company will investigate
        occurrences which may involve such violations and may involve, and cooperate with, law enforcement authorities
        in prosecuting users who are involved in such violations.
      </p>
      <p>Specific Prohibited Uses.</p>
      <p>
        The Web Site may be used only for lawful purposes by individuals seeking employment and career information and
        employers seeking employees. The Company specifically prohibits any use of the Web Site, and all users agree not
        to use the Web Site, for any of the following:
      </p>
      <ul>
        <li>
          <p>
            Posting any incomplete, false or inaccurate biographical information or information which is not your own
            accurate resume (living individual seeking employment on a full-time or part-time basis on his or her own
            behalf).
          </p>
        </li>
        <li>
          <p>Deleting or revising any material posted by any other person or entity.</p>
        </li>
        <li>
          <p>
            Using any device, software or routine to interfere or attempt to interfere with the proper working of this
            Web Site or any activity being conducted on this site.
          </p>
        </li>
        <li>
          <p>
            Taking any action which imposes an unreasonable or disproportionately large load on this Web Site’s
            infrastructure.
          </p>
        </li>
        <li>
          <p>
            If you have a password allowing access to a non-public area of this Web Site, disclosing to or sharing your
            password with any third parties or using your password for any unauthorized purpose.
          </p>
        </li>
        <li>
          <p>
            Notwithstanding anything to the contrary contained herein, using or attempting to use any engine, software,
            tool, Service Provider or other device or mechanism (including without limitation browsers, spiders, robots,
            avatars or intelligent Service Providers) to navigate or search this Web Site other than the search engine
            and search Service Providers available from the Company on this Web Site and other than generally available
            third party web browsers (e.g., Netscape Navigator, Microsoft Explorer).
          </p>
        </li>
        <li>
          <p>
            Attempting to decipher, decompile, disassemble or reverse engineer any of the software comprising or in any
            way making up a part of the Web Site.
          </p>
        </li>
        <li>
          <p>
            Aggregating, copying or duplicating in any manner any of the materials or information available from the Web
            Site.
          </p>
        </li>
        <li>
          <p>
            Framing of or linking to any of the materials or information available from the Web Site. User Information.
            When you register for the Web Site, you will be asked to provide the LiveXchange with certain information
            including, without limitation, a valid email address (your &quot;Information&quot;). In addition to the
            terms and conditions that may be set forth in any privacy policy on this Web Site, you understand
            LiveXchange will not disclose to any third party your name, address, e-mail address or telephone number
            without your prior consent, except to the extent necessary or appropriate to comply with applicable laws or
            in legal proceedings where such information is relevant. Please see the Company’s Privacy Policy for further
            details regarding your Information.
          </p>
        </li>
      </ul>
      <p>User Submissions.</p>
      <p>
        As a user, you are responsible for your own communications and are responsible for the consequences of their
        posting. You must not, and by using this Web Site you agree not to, do the following things: post material that
        is copyrighted, unless you are the copyright owner or have the permission of the copyright owner to post it;
        post material that reveals trade secrets, unless you own them or have the permission of the owner; post material
        that infringes on any other intellectual property rights of others or on the privacy or publicity rights of
        others; post material that is obscene, defamatory, threatening, harassing, abusive, hateful, or embarrassing to
        another user or any other person or entity; post a sexually-explicit image or statement; post advertisements or
        solicitations of business, post chain letters or pyramid schemes; impersonate another person; or post material
        that contains viruses, Trojan horses, worms, time bombs, cancelbots or other computer programming routines or
        engines that are intended to damage, detrimentally interfere with, surreptitiously intercept or expropriate any
        system, data or information.
      </p>
      <p>
        LiveXchange acts as a passive conduit for the online distribution and publication of user-submitted information
        and has no obligation to screen communications or information in advance and is not responsible for screening or
        monitoring material posted by users. If notified by a user of communications which allegedly do not conform to
        these Terms and Conditions, LiveXchange may investigate the allegation and determine in good faith and its sole
        discretion whether to remove or request the removal of the communication. LiveXchange has no liability or
        responsibility to users for performance or nonperformance of such activities. LiveXchange reserves the right to
        expel users and prevent their further access to the Web Site for violating the Terms and Conditions or the law
        and the right to remove communications which are abusive, illegal, or disruptive. The Company may take any
        action with respect to user-submitted information that it deems necessary or appropriate in its sole discretion
        if it believes it may create liability for the Company or may cause the Company to lose (in whole or in part)
        the services of its ISPs or other suppliers.
      </p>
      <p>The Company&apos;s Liability.</p>
      <p>
        LiveXchange is only a venue. This Web Site acts as a venue for employers to post gig opportunities and
        candidates to post resumes and does not screen or censor the listings offered. The Company is not involved in
        the actual transaction between employers and candidates. As a result, the Company has no control over the
        quality, safety or legality of the gigs or resumes posted, the truth or accuracy of the listings, the ability of
        employers to offer gig opportunities to candidates or the ability of candidates to fill gig openings. In
        addition, note that there are risks, including but not limited to the risk of physical harm, of dealing with
        strangers, foreign nationals, underage persons or people acting under false pretenses. You assume all risks
        associated with dealing with other users with whom you come in contact through the Web Site.
      </p>
      <p>
        Because user authentication on the Internet is difficult, LiveXchange cannot and does not confirm that each user
        is who they claim to be. Because we do not and cannot be involved in user-to-user dealings or control the
        behavior of participants on LiveXchange in the event that you have a dispute with one or more users, you release
        the Company (and our Service Providers and employees) from claims, demands and damages (contractual and
        extra-contractual, actual and consequential, direct and indirect, punitive) of every kind and nature, known and
        unknown, suspected and unsuspected, disclosed and undisclosed, arising out of or in any way connected with such
        disputes.
      </p>
      <p>
        We are under no legal obligation to, and generally do not, control the information provided by other users which
        is made available through the Web Site. By its very nature, other people’s information may be offensive, harmful
        or inaccurate, and in some cases will be mislabeled or deceptively labeled. We expect that you will use caution
        and common sense when using this Web Site.
      </p>
      <p>
        The Material may contain inaccuracies or typographical errors. The Company makes no representations about the
        accuracy, reliability, completeness, or timeliness of the Web Site or the Material. The use of the Web Site and
        the Material is at your own risk. Changes are periodically made to the Web Site and may be made at any time.
      </p>
      <p>
        You acknowledge and agree that you are solely responsible for the form, content and accuracy of any resume or
        material contained therein placed by you on the Web Site. Employers are solely responsible for their postings on
        the Web Site.
      </p>
      <p>
        The Company is not to be considered to be an employer with respect to your use of the Web Site and the Company
        shall not be responsible for any employment decisions, for whatever reason made, made by any entity posting gigs
        on the Web Site.
      </p>
      <p>No Warranties</p>
      <p>
        THE COMPANY DOES NOT WARRANT THAT THE WEB SITE WILL OPERATE ERROR-FREE OR THAT THE WEB SITE AND ITS SERVER ARE
        FREE OF COMPUTER VIRUSES OR OTHER HARMFUL MECHANISMS. IF YOUR USE OF THE WEB SITE OR THE MATERIAL RESULTS IN THE
        NEED FOR SERVICING OR REPLACING EQUIPMENT OR DATA, THE COMPANY IS NOT RESPONSIBLE FOR THOSE COSTS.
      </p>
      <p>
        THE WEB SITE AND MATERIAL ARE PROVIDED ON AN &quot;AS IS&quot; BASIS WITHOUT ANY WARRANTIES OF ANY KIND. THE
        COMPANY, TO THE FULLEST EXTENT PERMITTED BY LAW, DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING
        THE WARRANTY OF MERCHANTABILITY, QUALITY, FITNESS FOR PARTICULAR PURPOSE AND NON-INFRINGEMENT. THE COMPANY MAKES
        NO WARRANTIES ABOUT THE ACCURACY, RELIABILITY, COMPLETENESS, OR TIMELINESS OF THE MATERIAL, SERVICES, SOFTWARE,
        TEXT, GRAPHICS, AND LINKS.
      </p>

      <p>Disclaimer of Consequential Damages.</p>
      <p>
        IN NO EVENT SHALL THE COMPANY, ITS SUPPLIERS, OR ANY THIRD PARTIES MENTIONED ON THE WEB SITE BE LIABLE FOR ANY
        DAMAGES WHATSOEVER, WHETHER FOR BODILY, MORAL OR MATERIAL INJURY (INCLUDING, WITHOUT LIMITATION, INDIRECT,
        PUNITIVE, INCIDENTAL AND CONSEQUENTIAL DAMAGES, LOST PROFITS, OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS
        INTERRUPTION) RESULTING FROM THE USE OR INABILITY TO USE THE WEB SITE AND THE MATERIAL, WHETHER BASED ON
        WARRANTY, CONTRACTUAL OR EXTRA-CONTRACTUAL LIABILITY, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT THE COMPANY
        IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      </p>
      <p>Links to Other Sites.</p>
      <p>
        The Web Site contains links to third party web sites. These links are provided solely as a convenience to you
        and not as an endorsement by the Company of the contents on such third-party Web sites. The Company is not
        responsible for the content of linked third-party sites and does not make any representations regarding the
        content or accuracy of materials on such third party Web sites. If you decide to access linked third party Web
        sites, you do so at your own risk.
      </p>

      <p>Limitation of Liability.</p>
      <p>
        The aggregate liability for the Company to you for all claims arising from the use of the Materials is limited
        to $100.
      </p>

      <p>Termination.</p>
      <p>
        The Company reserves the right, at its sole discretion, to pursue all of its legal remedies, including but not
        limited to deletion of your postings from this Web Site and immediate termination of your registration with or
        ability to access the Web Site and/or any other service provided to you by the Company, upon any breach by you
        of these Terms and Conditions or if the Company is unable to verify or authenticate any information you submit
        to the Web Site registration with or ability to access the Web Site.
      </p>

      <p>Indemnity.</p>
      <p>
        You agree to defend, indemnify, and hold harmless LiveXchange. its officers, directors, employees and Service
        Providers, from and against any claims, actions or demands, including without limitation reasonable legal and
        accounting fees (judicial and extra-judicial), alleging or resulting from your use of the Material or your
        breach of the terms of these Terms and Conditions. The Company shall provide notice to you promptly of any such
        claim, suit, or proceeding and shall assist you, at your expense, in defending any such claim, suit or
        proceeding.
      </p>
      <p>General.</p>
      <p>
        The Company makes no claims that the Materials may be lawfully viewed or downloaded outside of Canada. Access to
        the Materials may not be legal by certain persons or in certain countries. If you access the Web Site from
        outside of Canada, you do so at your own risk and are responsible for compliance with the laws of your
        jurisdiction. These Terms and conditions are governed by the internal substantive laws of the Province of
        Quebec, Canada, without respect to its conflict of laws principles. Jurisdiction for any claims arising under
        this agreement shall lie exclusively with the courts having jurisdiction within the judicial district of
        Montreal, Province of Quebec. If any provision of these Terms and Conditions are found to be invalid by any
        court having competent jurisdiction, the invalidity of such provision shall not affect the validity of the
        remaining provisions of these Terms and Conditions, which shall remain in full force and effect. No waiver of
        any term of these Terms and Conditions shall be deemed a further or continuing waiver of such term or any other
        term. Except as expressly provided in additional terms of use for areas of the Web Site a particular &quot;Legal
        Notice,&quot; or Software License or material on particular Web pages, these Terms and Conditions constitute the
        entire agreement between you and the Company with respect to the use of Web Site. No changes to these Terms and
        Conditions shall be made except by a revised posting on this page.
      </p>
    </div>
  );
};

const BlueH2 = styled.h2`
  color: #008acd;
`;
